import React from 'react';

import { useRecoilQuery } from '../../../../../hooks/useRecoilQuery';
import { directTreasuryMarketStatusQuery } from '../../../../../store/product/selectors';
import { ProductButtonProps } from '../../../../BatchTicket/components/DynamicButton';
import { ApplicationButton } from '../../components/ApplicationButton';

export const DirectTreasuryButton: React.FC<ProductButtonProps<'directTreasury'>> = (props) => {
  const { data } = useRecoilQuery(directTreasuryMarketStatusQuery);

  const forceButtonDisable = !data || !data?.isOpen;

  return (
    <ApplicationButton
      {...props}
      isDisabled={props.isDisabled || forceButtonDisable}
      idSelector="productIdNormalized"
    />
  );
};
